import React from "react";

const Banner = () => {
    return (
        <>
            <section className="banner-con position-relative">
                <div className="container position-relative">
                    <div className="row">
                        <div className="col-xl-7 col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="banner_content" data-aos="fade-up">
                                <h3>Welcome to Derby</h3>
                                <h1>Timeless <span>Candy</span> Craftsmanship</h1>
                                <p>Enjoy the sweetness of classNameic candies crafted with care and finest ingredients.</p>
                                <a href="/lollipops" className="text-decoration-none all_button">Shop the Collection<i
                                    className="fa-solid fa-arrow-right"></i></a>
                            </div>
                        </div>
                        <div className="col-xl-5 col-lg-6 col-md-12 col-sm-12 col-12"></div>
                    </div>
                    <figure className="banner-image mb-0">
                        <img src="https://res.cloudinary.com/dzk6ng1ba/image/upload/v1743074948/banner-image1_c1lqxc.png" alt="image-4" className="img-fluid" />
                    </figure>
                </div>
            </section>
        </>
    )
};
export default Banner;